import { SyntheticEvent } from 'react'

export class ImgHelper {
  public static handleImageLoadingFailure(e: SyntheticEvent<HTMLImageElement>) {
    const target = e.target as HTMLImageElement
    const fallbackUrl = target.getAttribute('data-fallback')
    if (fallbackUrl) {
      target.src = fallbackUrl
    }
    target.onerror = null
  }
}
